import React from 'react';
import PropTypes from 'prop-types';
import { ALLOCATION_UPDATE_NAME, BENCHMARK_CHART_NAME } from '../accountPerformance.consts';
import BenchmarkChartLegendItem from './BenchmarkChartLegendItem';
import ChartLegendItem, { ChartLegendIcon } from './ChartLegendItem';

const LegendItemPicker = ({
  name, color, showBenchmark, toggleShowBenchmark,
}) => {
  switch (name) {
    case ALLOCATION_UPDATE_NAME:
      return (<ChartLegendItem
        legendIcon={<ChartLegendIcon color={color} type="circle" />}
        name={name}
      />);
    case BENCHMARK_CHART_NAME:
      return (<BenchmarkChartLegendItem
        name={name}
        color={color}
        showBenchmark={showBenchmark}
        toggleShowBenchmark={toggleShowBenchmark}
      />);
    default:
      return (<ChartLegendItem
        legendIcon={<ChartLegendIcon color={color} type="line" />}
        name={name}
      />);
  }
};

LegendItemPicker.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  toggleShowBenchmark: PropTypes.func.isRequired,
  showBenchmark: PropTypes.bool.isRequired,
};


export default LegendItemPicker;
